import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const menu = theme => css`
  [role='menuitem'] {
    &.active,
    &:hover {
      .menu-item-icon {
        background-color: ${theme.color.monochrome.white};
      }
    }
  }

  .shopify,
  .zapier {
    margin: ${rem(5)};
  }
  .recharge,
  .stripe {
    margin: ${rem(10)};
  }
`

export const styles = {
  menu,
}
